var _defs, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrders(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44,
    height: 39
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "orders_svg__a",
    d: "M0 .674h30.286v27.702H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "orders_svg__c",
    d: "M.295.505h8.481v8.481H.296z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M20.05 14.466a.623.623 0 00.538-.309l1.446-2.454a.626.626 0 10-1.08-.636l-1.128 1.92-3.569-2.059 1.126-1.91a.626.626 0 10-1.08-.635l-1.446 2.454a.631.631 0 00-.066.476.63.63 0 00.293.384l4.652 2.685a.626.626 0 00.313.084m-4.819 7.237a.763.763 0 101.324.765.765.765 0 10-1.324-.765m2.581 1.491a.765.765 0 101.324.765.765.765 0 00-1.324-.765m-5.164-2.983a.765.765 0 101.324.766.765.765 0 00-1.324-.766"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.749 .071)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "orders_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#orders_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M16.976 27.183l.839-.61-14.739-8.51L11.338 3.75l15.872 9.163-7.577 13.124 1.068.08c.386.03.779.104 1.168.22l.508.148 7.736-13.397c.17-.294.218-.654.128-.982a1.303 1.303 0 00-.603-.794L11.514.849a1.304 1.304 0 00-1.776.473L.174 17.888a1.302 1.302 0 00.476 1.776l15.09 8.712.365-.407c.262-.29.555-.556.871-.786",
    mask: "url(#orders_svg__b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M3.153 26.177a.625.625 0 00.228.856l11.474 6.624c.076-.42.195-.833.36-1.239l-11.208-6.47a.623.623 0 00-.854.23"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.488 30.025)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "orders_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#orders_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M6.378 5.809a2.123 2.123 0 01-2.903.779 2.12 2.12 0 01-.779-2.905 2.127 2.127 0 113.681 2.125m.28-4.734A4.231 4.231 0 004.54.505c-1.511 0-2.92.812-3.675 2.121A4.217 4.217 0 00.44 5.843a4.214 4.214 0 001.975 2.575 4.25 4.25 0 002.118.569c1.511 0 2.92-.814 3.675-2.121a4.246 4.246 0 00-1.551-5.792",
    mask: "url(#orders_svg__d)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M42.187 11.644l.413 1.546-4.758 1.276-.416-1.546 4.76-1.276zm-6.033 1.363l.309 1.154-.202-.757-1.919.515a.616.616 0 00-.38.29l-9.036 15.653c.342.271.65.575.923.903l9.068-15.704 1.667-.448.11.413a1.006 1.006 0 001.233.713l5.233-1.403a.993.993 0 00.613-.468.998.998 0 00.1-.765l-.539-2.02a1.01 1.01 0 00-1.234-.712l-5.236 1.404a1.008 1.008 0 00-.71 1.232z"
  }))));
}
export default SvgOrders;